import { createResourceStore } from "@/lib/resource";
import type { FinanceAccount } from "./FinanceAccount";

export interface FinanceTransfer {
  id: string;
  amount: number;
  from_account_id: string;
  to_account_id: string;
  created_at: string;
  updateAt: string;
  from_account: FinanceAccount;
  to_account: FinanceAccount;
}

export const useFinanceTransfer =
  createResourceStore<FinanceTransfer>("finance-transfers");
